import React, {useState} from 'react';
import './ShopPremiumTab.css';
import {PREMIUM_CONFIGS} from '../../../../configs/premium';
import ShopPremiumItem from '../ShopPremiumItem/ShopPremiumItem';
import PremiumInfoModal from '../../../Modals/PremiumInfoModal/PremiumInfoModal';

function ShopPremiumTab() {
  // Покупка премиума пока недоступна — по «Скоро» открывается модалка с
  // описанием преимуществ (стиль модалки покупки сундука)
  const [modalPremium, setModalPremium] = useState(null);

  return (
    <div className="shop-tab-content">
      <div className="shop-premium-grid">
        {PREMIUM_CONFIGS.map((premium) => (
          <ShopPremiumItem
            key={premium.id}
            premium={premium}
            onComingSoonClick={() => setModalPremium(premium)}
          />
        ))}
      </div>

      {modalPremium && (
        <PremiumInfoModal
          premium={modalPremium}
          onClose={() => setModalPremium(null)}
        />
      )}
    </div>
  );
}

export default ShopPremiumTab;
